<template>
  <div class="desktop-only">
    <div class="desktop-only__card">
      <div class="desktop-only__icon">
        <v-icon icon="mdi-monitor" size="34" />
      </div>
      <h1 class="desktop-only__title">{{ title }}</h1>
      <p class="desktop-only__message">{{ message }}</p>
      <v-btn class="desktop-only__action" color="primary" rounded variant="flat" @click="goToDashboard">
        Back to dashboard
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useRequirementsStore } from "@/stores";
import { homePageFor } from "@/constants/worklistSections";

defineProps({
  title: { type: String, default: "Best viewed on desktop" },
  message: {
    type: String,
    default: "This page isn't built for small screens. Open it on a computer to continue.",
  },
});

const router = useRouter();
const requirementsStore = useRequirementsStore();

function goToDashboard() {
  const page = homePageFor(requirementsStore.clientConfig?.defaultPostLoginPage, requirementsStore.visibleModules);
  router.push({ name: page });
}
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.desktop-only {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 32px 20px;
}

.desktop-only__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 360px;
}

.desktop-only__icon {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($lh_color_blue, 0.1);
  color: $lh_color_blue;
  margin-bottom: 20px;
}

.desktop-only__title {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: $lh_color_navy_dark;
  margin: 0 0 10px;
}

.desktop-only__message {
  font-size: 14.5px;
  line-height: 21px;
  color: $lh_color_blue_gray;
  margin: 0 0 24px;
}

.desktop-only__action {
  text-transform: none;
  letter-spacing: normal;
}
</style>
